import AdminConfig from './Admin';
import ProducerConfig from './Producer';

export default [...AdminConfig, ...ProducerConfig];
